import React from 'react';
import { Helmet } from 'react-helmet';

interface Props {
  title: string;
}

export const SeoTitle = ({ title }: Props) => <Helmet title={title} />;
